import PropTypes from 'prop-types'

import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import {Checkbox, CHECKBOX_VARIANTS} from '@adv-mt/ui/checkbox'
import {Field} from '@adv-mt/ui/field'
import {Input} from '@adv-mt/ui/input'
import {Textarea, TEXTAREA_RESIZES, TEXTAREA_SIZES} from '@adv-mt/ui/textarea'

import {getFieldConstraintError} from '../utils/validateComplaintField.js'

const getConstraintProperty = (constraints = [], property) =>
  constraints.find(constraint => property in constraint.property)?.property[property]

const getConstraintMessage = (constraints = [], property) =>
  constraints.find(constraint => property in constraint.property)?.message

const ComplaintFormConfigField = ({field, hasAttemptedSubmit, onChange, value, className = ''}) => {
  const {constraints, display, hint, label, required} = field
  const checkboxId = `${field.id}-checkbox`
  const textareaId = `${field.id}-textarea`
  const inputId = `${field.id}-input`

  const maxLength = getConstraintProperty(constraints, 'maxlength')
  const pattern = getConstraintProperty(constraints, 'pattern')

  const constraintError = hasAttemptedSubmit && getFieldConstraintError(field, value)
  const isInvalid = Boolean(constraintError)
  const errorMessage = isInvalid && getConstraintMessage(constraints, constraintError)

  if (display === 'checkbox') {
    return (
      <Field.Root className={`${className}-checkbox`}>
        <Checkbox
          aria-invalid={isInvalid || undefined}
          variant={errorMessage ? CHECKBOX_VARIANTS.ERROR : undefined}
          checked={Boolean(value)}
          onCheckedChange={onChange}
          required={required}
          id={checkboxId}
        />
        <Field.Label htmlFor={checkboxId}>{label}</Field.Label>
        {errorMessage && (
          <Field.Error match icon={<IconClose />}>
            {errorMessage}
          </Field.Error>
        )}
      </Field.Root>
    )
  }

  if (display === 'multiline') {
    return (
      <Field.Root className={`${className}-textarea`}>
        <Field.Label htmlFor={textareaId}>{label}</Field.Label>
        <Textarea
          aria-invalid={isInvalid || undefined}
          id={textareaId}
          maxLength={maxLength && Number(maxLength)}
          onChange={event => onChange(event.target.value)}
          placeholder={hint}
          required={required}
          resize={TEXTAREA_RESIZES.VERTICAL}
          size={TEXTAREA_SIZES.LONG}
          value={value || ''}
        />
        {errorMessage && (
          <Field.Error match icon={<IconClose />}>
            {errorMessage}
          </Field.Error>
        )}
      </Field.Root>
    )
  }

  return (
    <Field.Root className={`${className}-input`}>
      <Field.Label htmlFor={inputId}>{label}</Field.Label>
      <Input
        aria-invalid={isInvalid || undefined}
        id={inputId}
        maxLength={maxLength && Number(maxLength)}
        onChange={event => onChange(event.target.value)}
        pattern={pattern}
        placeholder={hint}
        required={required}
        type={display === 'email' ? 'email' : 'text'}
        value={value || ''}
      />
      {errorMessage && (
        <Field.Error match icon={<IconClose />}>
          {errorMessage}
        </Field.Error>
      )}
    </Field.Root>
  )
}

ComplaintFormConfigField.propTypes = {
  field: PropTypes.shape({
    constraints: PropTypes.array,
    display: PropTypes.string,
    hint: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.node,
    required: PropTypes.bool
  }).isRequired,
  hasAttemptedSubmit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string
}

export default ComplaintFormConfigField
